export const getFetkeyVariablePrefix = () => {
  // return window.innerWidth > 768 ? 'P_' : 'M_';

  // 20200921 IT 和 User 確認, AA Code 有上, Fetkey 舊不需要分大小網
  return 'P_';
};
